import {Box, Card, Switch, switchClasses, type SxProps, type Theme, Tooltip, Typography} from "@mui/material";
import {InfoOutlined, PinchRounded} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";

export interface CompactModeButtonProps {
    isInCompactMode: boolean | undefined;
    setIsInCompactMode: React.Dispatch<React.SetStateAction<boolean | undefined>>;
}

export const CompactModeButton: React.FC<CompactModeButtonProps> = ({isInCompactMode, setIsInCompactMode}) => {
    const {t} = useTranslation('components', {keyPrefix: 'panel-sections.drawers.settings-drawer.compact-mode'});

    const innerCardSx = React.useCallback((selected: boolean): SxProps<Theme> => ({
        minHeight: 100,
        borderRadius: 2,
        padding: 2,
        borderColor: (theme) => `rgba(${theme.vars.palette.grey['500Channel']} / 12%)`,
        backgroundColor: 'transparent',
        ...(selected && {
            backgroundColor: (theme) => `rgba(${theme.vars.palette.grey['500Channel']} / 8%)`,
        }),
        "&:hover": {
            backgroundColor: (theme) => `rgba(${theme.vars.palette.grey['500Channel']} / 8%)`,
        }
    }), []);

    return (
        <>
            <Card variant={'outlined'} sx={innerCardSx(false)}>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2,}}>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5}}>
                        <Box component={PinchRounded} sx={{width: 24, height: 24}}/>
                        <Switch
                            size={'small'}
                            sx={{[`.${switchClasses.track}`]: {borderRadius: '21px'}}}
                            color={'primary'}
                            checked={isInCompactMode}
                            onChange={(event, checked) => setIsInCompactMode(checked)}
                        />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5}}>
                        <Typography variant={'body2'} sx={{fontWeight: 500}}>
                            {t(t => t.title)}
                        </Typography>
                        <Tooltip title={t(t => t.description)}>
                            <InfoOutlined sx={{color: 'grey', width: 20, height: 20}}/>
                        </Tooltip>
                    </Box>
                </Box>
            </Card>
        </>
    );
}